import { Component, Input, OnInit } from '@angular/core';
import { InstrumentLite } from '@toro/common/shared/models/quote/instrument-lite.model';
import { STOCK_LOGO_PLACEHOLDER } from '@toro/common/shared/resources/consts';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { CheckoutService } from '../../../services/checkout.service';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { AnalysisPreviewDialogComponent } from '../../../shared/panels/analysis-preview-dialog/analysis-preview-dialog.component';
import { Router } from '@angular/router';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { StockResearchTrendAction } from '../../../state-management/stock-research-trend/stock-research-trend.action';

@Component({
    selector: 'market-card-mobile',
    templateUrl: './market-card-mobile.component.html',
    styleUrls: ['./market-card-mobile.component.scss'],
})
export class MarketCardMobileComponent extends DisposableSafelly implements OnInit {

    @Input() public stockDetails: InstrumentLite;
    @Input() public isPermitedOperation: boolean = true;

    constructor(
        private store: Store<AppState>,
        private checkoutService: CheckoutService,
        private dialogService: DialogsService,
        private router: Router,
    ) {
        super();
    }

    public get isFuture() {
        return this.stockDetails.typeMarket === OrderMarketTypeEnum.Future;
    }

    public ngOnInit() {
        this.disposableSubscriptions.push(
            this.checkoutService.getQuoteStoreData(this.stockDetails.active)
                .subscribe((quote) => {
                    if (quote) {
                        this.stockDetails.variation = quote.Variation;
                        this.stockDetails.unitPrice =
                            quote.PriceLastTrade ||
                            quote.OpeningPrice ||
                            quote.ClosingPricePreviousDay ||
                            quote.priceLastTrade ||
                            quote.openingPrice ||
                            quote.closingPricePreviousDay;
                    }
                }),
        );
    }

    public showAnalysisPreview() {
        if (!this.isPermitedOperation) return;

        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.stockDetails.active });
        this.store.dispatch({ type: StocksMarketAction.getTrends, payload: this.stockDetails.active });
        this.store.dispatch({ type: StockResearchTrendAction.getCompanyTrend, payload: { symbol: this.stockDetails.active } });
        this.store.dispatch({ type: StockResearchTrendAction.getTrend, payload: { symbol: this.stockDetails.active, time: 'Months' } });
        this.router.navigate([], { queryParams: { ativo: this.stockDetails.active } });
        this.dialogService.showComponentAsAsidePanel(AnalysisPreviewDialogComponent, true);
    }

    public noLogoHandler(event) {
        this.stockDetails.logoPath = STOCK_LOGO_PLACEHOLDER;
    }
}
